/* Saint Love Atleet theme scripts — vanilla, no dependencies */
(function () {
  "use strict";

  /* ---------- Mega menu (hover intent + klik/tap + toetsenbord) ---------- */
  document.documentElement.classList.add("js-mega");
  (function megaMenu() {
    var OPEN_DELAY = 40;
    var CLOSE_DELAY = 220;
    var canHover =
      window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    function init() {
      var menus = [].slice.call(document.querySelectorAll("[data-mega]"));
      if (!menus.length) return;

      function close(menu) {
        clearTimeout(menu._openT);
        menu.classList.remove("is-open");
        var t = menu.querySelector("[data-mega-trigger]");
        if (t) t.setAttribute("aria-expanded", "false");
      }
      function closeAll(except) {
        menus.forEach(function (m) {
          if (m !== except) close(m);
        });
      }
      function position(menu) {
        var panel = menu.querySelector("[data-mega-panel]");
        if (!panel) return;
        panel.style.left = "0px";
        var pad = 16;
        var rect = panel.getBoundingClientRect();
        var shift = 0;
        if (rect.right > window.innerWidth - pad) {
          shift = window.innerWidth - pad - rect.right;
        }
        if (rect.left + shift < pad) {
          shift = pad - rect.left;
        }
        if (shift) panel.style.left = shift + "px";
      }
      function open(menu) {
        clearTimeout(menu._closeT);
        closeAll(menu);
        menu.classList.add("is-open");
        var t = menu.querySelector("[data-mega-trigger]");
        if (t) t.setAttribute("aria-expanded", "true");
        position(menu);
      }

      menus.forEach(function (menu) {
        var trigger = menu.querySelector("[data-mega-trigger]");
        if (!trigger) return;

        menu.addEventListener("mouseenter", function () {
          clearTimeout(menu._closeT);
          menu._openT = setTimeout(function () {
            open(menu);
          }, OPEN_DELAY);
        });
        menu.addEventListener("mouseleave", function () {
          clearTimeout(menu._openT);
          menu._closeT = setTimeout(function () {
            close(menu);
          }, CLOSE_DELAY);
        });
        menu.addEventListener("focusin", function () {
          open(menu);
        });
        menu.addEventListener("focusout", function (e) {
          if (!menu.contains(e.relatedTarget)) close(menu);
        });

        trigger.addEventListener("click", function (e) {
          var isOpen = menu.classList.contains("is-open");
          if (canHover) return; // op desktop opent hover het menu; klik volgt de link
          e.preventDefault();
          if (isOpen) close(menu);
          else open(menu);
        });

        trigger.addEventListener("keydown", function (e) {
          if (e.key === "ArrowDown" || e.key === " " || e.key === "Spacebar") {
            e.preventDefault();
            open(menu);
            var first = menu.querySelector("[data-mega-panel] a");
            if (first) first.focus();
          }
        });
      });

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") closeAll(null);
      });
      document.addEventListener("click", function (e) {
        if (!e.target.closest("[data-mega]")) closeAll(null);
      });
      window.addEventListener("pagehide", function () {
        closeAll(null);
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();


  var money = function (cents) {
    var value = (cents / 100).toFixed(2).replace(".", ",");
    return "€ " + value;
  };

  /* ---------- Drawers ---------- */
  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    var closeBtn = el.querySelector("[data-drawer-close]");
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer(el) {
    if (!el) return;
    el.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-drawer-open]");
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute("data-drawer-open"));
      return;
    }
    if (e.target.closest("[data-drawer-close]") || e.target.classList.contains("drawer__overlay")) {
      closeDrawer(e.target.closest(".drawer"));
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document.querySelectorAll('.drawer[aria-hidden="false"]').forEach(closeDrawer);
    }
  });

  /* ---------- Announcement rotator ---------- */
  var announcements = document.querySelectorAll("[data-announcement-item]");
  if (announcements.length > 1) {
    var ai = 0;
    setInterval(function () {
      announcements[ai].classList.remove("is-active");
      ai = (ai + 1) % announcements.length;
      announcements[ai].classList.add("is-active");
    }, 4500);
  }

  /* ---------- Hero slider ---------- */
  document.querySelectorAll("[data-hero]").forEach(function (hero) {
    var slides = hero.querySelectorAll("[data-hero-slide]");
    var dots = hero.querySelectorAll("[data-hero-dot]");
    if (slides.length < 2) return;
    var index = 0;
    var timer;
    function show(i) {
      slides[index].classList.remove("is-active");
      if (dots[index]) dots[index].setAttribute("aria-current", "false");
      index = i;
      slides[index].classList.add("is-active");
      if (dots[index]) dots[index].setAttribute("aria-current", "true");
    }
    function start() {
      timer = setInterval(function () { show((index + 1) % slides.length); }, 6000);
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () { clearInterval(timer); show(i); start(); });
    });
    start();
  });

  /* ---------- Cart helpers ---------- */
  function refreshCart() {
    return fetch(window.SLA.routes.cart_url + ".js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle("hidden", cart.item_count === 0);
        });
        return fetch(window.location.pathname + "?section_id=cart-drawer")
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var fresh = doc.querySelector("[data-cart-drawer-body]");
            var target = document.querySelector("[data-cart-drawer-body]");
            if (fresh && target) target.innerHTML = fresh.innerHTML;
            var freshFoot = doc.querySelector("[data-cart-drawer-foot]");
            var foot = document.querySelector("[data-cart-drawer-foot]");
            if (freshFoot && foot) foot.innerHTML = freshFoot.innerHTML;
            return cart;
          })
          .catch(function () { return cart; });
      });
  }

  function addToCart(id, quantity, button) {
    if (button) { button.setAttribute("aria-disabled", "true"); button.dataset.label = button.textContent; button.textContent = "Toevoegen…"; }
    return fetch(window.SLA.routes.cart_add_url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || "Kon niet toevoegen");
        return refreshCart().then(function () { openDrawer("CartDrawer"); });
      })
      .catch(function (err) { alert(err.message); })
      .finally(function () {
        if (button) { button.removeAttribute("aria-disabled"); if (button.dataset.label) button.textContent = button.dataset.label; }
      });
  }

  document.addEventListener("click", function (e) {
    var quick = e.target.closest("[data-quick-add]");
    if (quick) {
      e.preventDefault();
      addToCart(quick.getAttribute("data-quick-add"), 1, quick);
      return;
    }
    var remove = e.target.closest("[data-cart-remove]");
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute("data-cart-remove"), 0);
      return;
    }
    var step = e.target.closest("[data-qty-step]");
    if (step) {
      e.preventDefault();
      var input = step.parentElement.querySelector("input");
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute("data-qty-step"), 10));
      input.value = next;
      if (input.hasAttribute("data-cart-qty")) changeLine(input.getAttribute("data-cart-qty"), next);
    }
  });

  function changeLine(key, qty) {
    fetch(window.SLA.routes.cart_change_url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () {
      if (document.body.classList.contains("template-cart")) { window.location.reload(); return; }
      refreshCart();
    });
  }

  document.addEventListener("change", function (e) {
    var input = e.target.closest("[data-cart-qty]");
    if (input) changeLine(input.getAttribute("data-cart-qty"), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------- Product form: variant selection ---------- */
  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    var root = form.closest("[data-product-root]") || document;
    var variants = JSON.parse(root.querySelector("[data-variants-json]").textContent);
    var idInput = form.querySelector("[data-variant-id]");
    var submit = form.querySelector("[data-add-button]");
    var priceEl = root.querySelector("[data-price]");
    var compareEl = root.querySelector("[data-compare-price]");

    function selected() {
      return Array.prototype.map.call(form.querySelectorAll("[data-option-index]"), function (group) {
        var checked = group.querySelector("input:checked");
        return checked ? checked.value : null;
      });
    }

    function update() {
      var picked = selected();
      var match = variants.filter(function (v) {
        return picked.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
      if (!match) {
        submit.setAttribute("aria-disabled", "true");
        submit.textContent = submit.getAttribute("data-label-unavailable") || "Niet beschikbaar";
        var dynWrapNone = root.querySelector("[data-dynamic-checkout]");
        if (dynWrapNone) dynWrapNone.classList.add("hidden");
        return;
      }
      idInput.value = match.id;
      var dynInput = root.querySelector("[data-dynamic-checkout-variant-id]");
      var dynWrap = root.querySelector("[data-dynamic-checkout]");
      if (dynInput) dynInput.value = match.id;
      if (dynWrap) {
        if (match.available) dynWrap.classList.remove("hidden");
        else dynWrap.classList.add("hidden");
      }
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.classList.remove("hidden");
        } else {
          compareEl.classList.add("hidden");
        }
      }
      var preorder = form.getAttribute("data-preorder") === "true";
      var L = function (n, f) { return submit.getAttribute("data-label-" + n) || f; };
      if (preorder) {
        submit.removeAttribute("aria-disabled");
        submit.textContent = L("preorder", "Pre-order");
      } else if (match.available) {
        submit.removeAttribute("aria-disabled");
        submit.textContent = L("add", "In winkelwagen");
      } else {
        submit.setAttribute("aria-disabled", "true");
        submit.textContent = L("soldout", "Uitverkocht");
      }
      var colorGroup = form.querySelector(".option--color input:checked");
      var cur = form.querySelector("[data-option-current]");
      if (cur && colorGroup) cur.textContent = colorGroup.value;
      if (colorGroup) showColorMedia(root, colorGroup.value);
      if (match.featured_image && match.featured_image.src) showVariantMedia(root, match.featured_image.src);
      var url = new URL(window.location.href);
      url.searchParams.set("variant", match.id);
      window.history.replaceState({}, "", url);
    }

    // Combinatie bestaat niet (bv. andere samenstelling in deze kleur)? Spring naar de eerste variant
    // met de zojuist gekozen waarde, zodat de klant nooit op "Niet beschikbaar" uitkomt.
    function corrigeer(e) {
      var groep = e && e.target && e.target.closest ? e.target.closest("[data-option-index]") : null;
      if (!groep) return;
      var groepen = Array.prototype.slice.call(form.querySelectorAll("[data-option-index]"));
      var idx = groepen.indexOf(groep);
      var picked = selected();
      var bestaat = variants.some(function (v) { return picked.every(function (val, i) { return val === null || v.options[i] === val; }); });
      if (bestaat || idx < 0) return;
      var kandidaten = variants.filter(function (v) { return v.options[idx] === picked[idx]; });
      // zoveel mogelijk van de andere keuzes (bv. maat) behouden
      kandidaten.sort(function (a, b) {
        var sa = 0, sb = 0;
        picked.forEach(function (val, i) { if (a.options[i] === val) sa++; if (b.options[i] === val) sb++; });
        return sb - sa;
      });
      var doel = kandidaten[0];
      if (!doel) return;
      groepen.forEach(function (g, i) {
        Array.prototype.forEach.call(g.querySelectorAll("input"), function (inp) { inp.checked = inp.value === doel.options[i]; });
      });
    }

    form.addEventListener("change", function (e) { corrigeer(e); update(); });
    update();

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var qtyInput = form.querySelector('input[name="quantity"]');
      addToCart(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1, submit);
    });
  });

  /* ---------- Gallery ---------- */
  function normalizeText(v) {
    return String(v || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function activateThumb(gallery, thumb) {
    var main = gallery.querySelector("[data-gallery-main]");
    if (!main || !thumb) return;
    main.src = thumb.getAttribute("data-src");
    var inner = thumb.querySelector("img");
    main.alt = inner ? inner.alt : "";
    gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (t) { t.setAttribute("aria-current", "false"); });
    thumb.setAttribute("aria-current", "true");
    if (typeof thumb.scrollIntoView === "function") {
      try { thumb.scrollIntoView({ block: "nearest", inline: "nearest" }); } catch (err) {}
    }
  }

  function showColorMedia(root, colorValue) {
    var gallery = (root || document).querySelector("[data-gallery]");
    if (!gallery) return;
    var color = normalizeText(colorValue);
    if (!color) return;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-gallery-thumb]"));
    var match = thumbs.filter(function (t) {
      var alt = normalizeText(t.getAttribute("data-media-alt"));
      return alt === color || alt.split(" ").indexOf(color) !== -1;
    })[0];
    // Geen foto voor deze kleur? Dan NIETS doen: de huidige grote foto en
    // actieve thumbnail blijven ongemoeid (geen fallback naar een andere kleur/foto).
    if (match) activateThumb(gallery, match);
  }

  // Toon de foto die in Shopify aan de gekozen variant gekoppeld is (combinatie + kleur)
  function showVariantMedia(root, src) {
    var gallery = (root || document).querySelector("[data-gallery]");
    if (!gallery || !src) return;
    var naam = String(src).split("?")[0].split("/").pop().replace(/\.[a-z]+$/i, "");
    if (!naam) return;
    var match = Array.prototype.slice.call(gallery.querySelectorAll("[data-gallery-thumb]")).filter(function (t) {
      var img = t.querySelector("img");
      return img && (img.getAttribute("src") || img.currentSrc || "").indexOf(naam) !== -1;
    })[0];
    if (match) activateThumb(gallery, match);
  }

  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () { activateThumb(gallery, thumb); });
    });
  });

  /* ---------- Sort / filter auto-submit ---------- */
  document.querySelectorAll("[data-auto-submit]").forEach(function (el) {
    el.addEventListener("change", function () { el.closest("form").submit(); });
  });

  refreshCart();
})();

/* Saint Love Atleet — extra modules (countdown, wishlist, predictive search, filters) */
(function () {
  "use strict";

  /* ---------- Countdown ---------- */
  document.querySelectorAll("[data-countdown]").forEach(function (el) {
    var target = new Date(el.getAttribute("data-countdown")).getTime();
    if (isNaN(target)) { el.classList.add("hidden"); return; }
    var pad = function (n) { return n < 10 ? "0" + n : "" + n; };
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { el.classList.add("hidden"); clearInterval(timer); return; }
      var s = Math.floor(diff / 1000);
      var set = function (sel, v) { var n = el.querySelector(sel); if (n) n.textContent = v; };
      set("[data-countdown-days]", Math.floor(s / 86400));
      set("[data-countdown-hours]", pad(Math.floor((s % 86400) / 3600)));
      set("[data-countdown-minutes]", pad(Math.floor((s % 3600) / 60)));
      set("[data-countdown-seconds]", pad(s % 60));
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ---------- Wishlist (localStorage) ---------- */
  var KEY = "sla-wishlist";
  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.querySelectorAll("[data-wishlist-count]").forEach(function (el) {
      el.textContent = list.length;
      el.classList.toggle("hidden", list.length === 0);
    });
  }
  function syncButtons() {
    var list = read();
    document.querySelectorAll("[data-wishlist-toggle]").forEach(function (btn) {
      var handle = btn.getAttribute("data-wishlist-toggle");
      btn.setAttribute("aria-pressed", list.indexOf(handle) > -1 ? "true" : "false");
    });
    write(list);
  }
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wishlist-toggle]");
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute("data-wishlist-toggle");
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); } else { list.push(handle); }
    write(list);
    syncButtons();
    if (document.querySelector("[data-wishlist-page]")) renderWishlist();
  });
  syncButtons();

  function renderWishlist() {
    var wrap = document.querySelector("[data-wishlist-page]");
    if (!wrap) return;
    var grid = wrap.querySelector("[data-wishlist-grid]");
    var empty = wrap.querySelector("[data-wishlist-empty]");
    var list = read();
    if (!list.length) { grid.hidden = true; grid.innerHTML = ""; empty.hidden = false; return; }
    empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = "";
    list.forEach(function (handle) {
      fetch("/products/" + handle + "?view=card")
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var card = doc.querySelector(".card");
          if (card) grid.appendChild(card);
        })
        .catch(function () {});
    });
  }
  renderWishlist();

  /* ---------- Header search toggle ---------- */
  (function () {
    var toggle = document.querySelector("[data-header-search-toggle]");
    var wrap = document.querySelector("[data-header-search]");
    if (!toggle || !wrap) return;
    var input = wrap.querySelector("[data-header-search-input]");
    function setOpen(open) {
      wrap.hidden = !open;
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (open && input) input.focus();
    }
    toggle.addEventListener("click", function () {
      setOpen(wrap.hidden);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !wrap.hidden) { setOpen(false); toggle.focus(); }
    });
    document.addEventListener("click", function (e) {
      if (wrap.hidden) return;
      if (!wrap.contains(e.target) && !toggle.contains(e.target)) setOpen(false);
    });
  })();

  /* ---------- Predictive search ---------- */

  document.querySelectorAll("[data-predictive-input]").forEach(function (input) {
    var results = input.closest(".search-wrap").querySelector("[data-predictive-results]");
    var timer;
    input.addEventListener("input", function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < 2) { results.hidden = true; results.innerHTML = ""; return; }
      timer = setTimeout(function () {
        fetch(window.SLA.routes.predictive_search_url + "?q=" + encodeURIComponent(term) + "&resources[type]=product&resources[limit]=6&section_id=predictive-search")
          .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var fresh = doc.querySelector("[data-predictive-list]");
            results.innerHTML = fresh ? fresh.innerHTML : "";
            results.hidden = !fresh || fresh.children.length === 0;
          })
          .catch(function () { results.hidden = true; });
      }, 250);
    });
    document.addEventListener("click", function (e) {
      if (!input.closest(".search-wrap").contains(e.target)) results.hidden = true;
    });
  });

  /* ---------- Filter panel toggle ---------- */
  document.querySelectorAll("[data-filters-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var panel = document.querySelector("[data-filters-panel]");
      if (!panel) return;
      var open = !panel.hidden;
      panel.hidden = open;
      btn.setAttribute("aria-expanded", open ? "false" : "true");
    });
  });

  /* ---------- Smart sticky header + scroll-to-top ---------- */
  (function () {
    var header = document.querySelector(".header");
    var scrollTopBtn = document.querySelector("[data-scroll-top]");
    var lastScrollY = 0;
    var ticking = false;
    var isMobile = window.matchMedia("(max-width: 999px)").matches;

    function updateHeader() {
      if (!header) return;
      header.classList.remove("header--up", "header--down");
    }

    function updateScrollTop() {
      if (!scrollTopBtn) return;
      scrollTopBtn.classList.toggle("is-visible", window.scrollY > 500);
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateHeader();
          updateScrollTop();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () {
      isMobile = window.matchMedia("(max-width: 999px)").matches;
    });

    if (scrollTopBtn) {
      scrollTopBtn.addEventListener("click", function () {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }

    updateHeader();
    updateScrollTop();
  })();

  /* ---------- Card colour swatch image switch ---------- */
  document.querySelectorAll("[data-swatch-color]").forEach(function (swatch) {
    var color = swatch.getAttribute("data-swatch-color").toLowerCase().replace(/\s+/g, " ");
    var card = swatch.closest("[data-card]");
    if (!card) return;
    var mainImg = card.querySelector("[data-card-img]:not(.card__img--alt)");
    var altImg = card.querySelector(".card__img--alt");
    var allImgs = Array.from(card.querySelectorAll("[data-card-img]"));
    var originalSrc = mainImg ? mainImg.src : "";

    function findBestSrc() {
      var exact = allImgs.filter(function (img) {
        var alt = (img.getAttribute("data-color") || "").toLowerCase();
        return alt.indexOf(color) > -1;
      });
      if (exact.length) return exact[0].src;
      return originalSrc;
    }

    function swap(src) {
      if (mainImg) mainImg.src = src;
    }

    swatch.addEventListener("mouseenter", function () { swap(findBestSrc()); });
    swatch.addEventListener("mouseleave", function () { swap(originalSrc); });
    swatch.addEventListener("click", function (e) {
      e.preventDefault();
      swap(findBestSrc());
    });
  });
})();



/* Locale switcher: submit on change */
(function () {
  document.addEventListener("change", function (event) {
    var select = event.target.closest ? event.target.closest("[data-locale-select]") : null;
    if (!select) return;
    var form = select.closest("form");
    if (form) form.submit();
  });
})();


/* Kleurstalen: extra kleuren onthullen */
(function () {
  document.addEventListener("click", function (event) {
    var btn = event.target.closest ? event.target.closest("[data-swatch-more]") : null;
    if (!btn) return;
    event.preventDefault();
    var group = btn.closest("[data-swatch-group]");
    if (!group) return;
    var hidden = group.querySelectorAll(".option__value--extra");
    for (var i = 0; i < hidden.length; i++) {
      hidden[i].classList.remove("is-hidden");
    }
    btn.setAttribute("aria-expanded", "true");
    btn.hidden = true;
  });
})();
